import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=b3b773ee&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=b3b773ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b773ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3b773ee')) {
      api.createRecord('b3b773ee', component.options)
    } else {
      api.reload('b3b773ee', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=b3b773ee&scoped=true&", function () {
      api.rerender('b3b773ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sq3CvAhtDUsr/JS/teamMember.vue"
export default component.exports